import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NavigationService } from '@cpd-app/core-module/services';
import { AuthFacade } from '@cpd-app/state/auth';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'cpd-passcode',
  templateUrl: './passcode.component.html',
  styleUrls: ['./passcode.component.scss']
})
export class PasscodeComponent implements OnInit, OnDestroy {
  public passcode = '';
  public errorMessage = '';
  public hide = signal(true);
  private destroy$ = new Subject<void>();

  constructor(
    private authFacade: AuthFacade,
    private navigationService: NavigationService
  ) {}

  public ngOnInit(): void {
    this.authFacade.submitPasscodeFailure$
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          this.errorMessage = 'Invalid passcode!';
        })
      )
      .subscribe();

    this.authFacade.isOverPasscode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOverPasscode) => {
        if (isOverPasscode) {
          this.navigationService.goToHomePage();
          return;
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onSubmit({ form }: NgForm): void {
    this.errorMessage = null;

    if (!form.valid) {
      return;
    }

    this.authFacade.submitPasscode(this.passcode);
  }

  public showPassword(event: MouseEvent): void {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }
}
